import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();
export const ADD_RULE_MODAL = "onAddRuleModal";

// INDIVIDUAL RESULTS
export const OPEN_COMPETITOR_RESULTS_OPTIONS_MODAL = "onOpenCompetitorResultsOptionsModal";
